// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header-nav .form-control {
    border: 1px solid #C1C1C1;
    border-radius: 5px 0 0 5px;
    height: 55px;
    font-size: 20px;
    line-height: 30px;
    max-width: 1200px;
}

#header-nav .input-group-text {
    background: #000000;
    border-radius: 0px 5px 5px 0px;
    border: 1px solid #C1C1C1;
}

.header-wrapper {
    max-width: 1783px;
}

.vertical-border {
    border-left: 1px solid #DBDBDB;
    height: 30px;
    margin: 0 10px;
}

.avatar-container {
    position: relative;
}

.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    background-size: cover;
    background-position: center;
    background-color: #DBDBDB;
}

.avatar-text {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
}

.mini-circle {
    background-color: green;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 0;
}
.sub-header{
    border: 1px solid #DBDBDB;
    padding: 0;
}
.sub-header #navbar-nav .nav-link {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    padding: 15px;
}

.sub-header #navbar-nav .nav-link.active {
    font-weight: 600;
    color:#fff;
    background-color: #00863F;
    border: none;
  }
.header-wrapper .input-group{
    justify-content: center;
}

#adminheader-nav .input-group-text{
    background-color: #FAFAFA;
    border: 1px solid #E6E6E6;
    border-right: none;
}

#adminheader-nav .form-control{
    background-color: #FAFAFA;
    border: 1px solid #E6E6E6;
    border-left: none;
}

#adminheader-nav .input-group{
    max-width: 860px;
}

#adminheader-nav .avatar{
    width: 40px;
    height: 40px;
}

.adminheader-wrapper.container{
    flex-wrap: nowrap;
}
.mob-navmenu{
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 10px;
}
.bell-link{
    background: #F2F2F2;
    border-radius: 50%;
    padding: 10px;
    max-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
}
.navbar-expand-lg .mob-navmenu.navbar-collapse{
    display: none!important;
}
.adminheader-wrapper .header-search .input-group-text{
    background-color: #FAFAFA;
}
.adminheader-wrapper .header-search .form-control{
    background-color: #FAFAFA;
    border-left: none;
    padding-left: 0;
    height: 48px;
}
.adminheader-wrapper .header-search{
    max-width: 860px;
}
@media(max-width:992px){
    .adminheader-wrapper .input-group-text{
        padding: 10px;
    }
    .navbar-expand-lg .mob-navmenu.navbar-collapse.show{
        display: block!important;
    }
}


.sub-header {
    background-color: #fff;
}

.navbar-toggler{
    margin: 10px 0;
}


.sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: none;
}

.customer-sidebar {
    position: fixed;
    top: 0;
    left: -350px;
    width: 350px; 
    height: 100%;
    background-color: #fff;
    overflow-y: auto;
    transition: left 0.3s ease; 
    z-index: 1001; 
}

.customer-sidebar.show {
    left: 0;
}

.mobile-subheader-nav .nav-link.active {
    font-weight: 600;
    color:#fff;
    background-color: #00863F;
    border: none;
  }

  .horizontal-border{
    border-bottom: 1px solid #DBDBDB;
    width: 100%;
    margin: 0 10px;
  }`, "",{"version":3,"sources":["webpack://./src/screens/header/header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,YAAY;EACd;AACF;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,cAAc;EAChB","sourcesContent":["#header-nav .form-control {\n    border: 1px solid #C1C1C1;\n    border-radius: 5px 0 0 5px;\n    height: 55px;\n    font-size: 20px;\n    line-height: 30px;\n    max-width: 1200px;\n}\n\n#header-nav .input-group-text {\n    background: #000000;\n    border-radius: 0px 5px 5px 0px;\n    border: 1px solid #C1C1C1;\n}\n\n.header-wrapper {\n    max-width: 1783px;\n}\n\n.vertical-border {\n    border-left: 1px solid #DBDBDB;\n    height: 30px;\n    margin: 0 10px;\n}\n\n.avatar-container {\n    position: relative;\n}\n\n.avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    position: relative;\n    background-size: cover;\n    background-position: center;\n    background-color: #DBDBDB;\n}\n\n.avatar-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.mini-circle {\n    background-color: green;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n.sub-header{\n    border: 1px solid #DBDBDB;\n    padding: 0;\n}\n.sub-header #navbar-nav .nav-link {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    padding: 15px;\n}\n\n.sub-header #navbar-nav .nav-link.active {\n    font-weight: 600;\n    color:#fff;\n    background-color: #00863F;\n    border: none;\n  }\n.header-wrapper .input-group{\n    justify-content: center;\n}\n\n#adminheader-nav .input-group-text{\n    background-color: #FAFAFA;\n    border: 1px solid #E6E6E6;\n    border-right: none;\n}\n\n#adminheader-nav .form-control{\n    background-color: #FAFAFA;\n    border: 1px solid #E6E6E6;\n    border-left: none;\n}\n\n#adminheader-nav .input-group{\n    max-width: 860px;\n}\n\n#adminheader-nav .avatar{\n    width: 40px;\n    height: 40px;\n}\n\n.adminheader-wrapper.container{\n    flex-wrap: nowrap;\n}\n.mob-navmenu{\n    background-color: #f0f0f0;\n    padding: 20px;\n    border-radius: 10px;\n}\n.bell-link{\n    background: #F2F2F2;\n    border-radius: 50%;\n    padding: 10px;\n    max-width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n}\n.navbar-expand-lg .mob-navmenu.navbar-collapse{\n    display: none!important;\n}\n.adminheader-wrapper .header-search .input-group-text{\n    background-color: #FAFAFA;\n}\n.adminheader-wrapper .header-search .form-control{\n    background-color: #FAFAFA;\n    border-left: none;\n    padding-left: 0;\n    height: 48px;\n}\n.adminheader-wrapper .header-search{\n    max-width: 860px;\n}\n@media(max-width:992px){\n    .adminheader-wrapper .input-group-text{\n        padding: 10px;\n    }\n    .navbar-expand-lg .mob-navmenu.navbar-collapse.show{\n        display: block!important;\n    }\n}\n\n\n.sub-header {\n    background-color: #fff;\n}\n\n.navbar-toggler{\n    margin: 10px 0;\n}\n\n\n.sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    display: none;\n}\n\n.customer-sidebar {\n    position: fixed;\n    top: 0;\n    left: -350px;\n    width: 350px; \n    height: 100%;\n    background-color: #fff;\n    overflow-y: auto;\n    transition: left 0.3s ease; \n    z-index: 1001; \n}\n\n.customer-sidebar.show {\n    left: 0;\n}\n\n.mobile-subheader-nav .nav-link.active {\n    font-weight: 600;\n    color:#fff;\n    background-color: #00863F;\n    border: none;\n  }\n\n  .horizontal-border{\n    border-bottom: 1px solid #DBDBDB;\n    width: 100%;\n    margin: 0 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
